export interface LatLng {
  lat: number;
  lng: number;
}

// Servidor público de demonstração do OSRM — gratuito, sem chave de API.
const OSRM_BASE_URL = 'https://router.project-osrm.org';

// Busca o traçado real das ruas entre os pontos (na ordem dada) via OSRM.
// Retorna null se a busca falhar — quem chamar deve manter uma linha reta como fallback.
export async function fetchRoadGeometry(points: LatLng[]): Promise<[number, number][] | null> {
  if (points.length < 2) return null;
  try {
    const coords = points.map((p) => `${p.lng},${p.lat}`).join(';');
    const res = await fetch(`${OSRM_BASE_URL}/route/v1/driving/${coords}?overview=full&geometries=geojson`);
    const data = await res.json();
    if (data.code !== 'Ok' || !data.routes?.[0]) return null;
    return data.routes[0].geometry.coordinates.map((c: [number, number]) => [c[1], c[0]] as [number, number]);
  } catch {
    return null;
  }
}
